import { useMutation, useQueryClient } from "react-query";
import React from "react";
import * as wf from "@qpr/client-api-workflow";
const useUpdateWorkflowState = (wfId?: string) => {
  const queryClient = useQueryClient();
  const invalidateCache = React.useMemo(
    () => ({
      mutationKey: wfId,
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey.indexOf("data-") >= 0,
        });
      },
    }),
    [queryClient]
  );
  // was: types.MeasurePayload

  return useMutation(
    async (data: { workflowId: string; action: string; message: string }) => {
      const wfStateUpdate = await wf.updateWorkflowInstanceState({
        id: data.workflowId,
        transition: {
          transition: data.action,
          message: data.message,
        },
      });
    },
    invalidateCache
  );
};

export default useUpdateWorkflowState;
